'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskContentModel = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class2, _temp2;

var _mobx = require('mobx');

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _cloner = require('cloner');

var _simgateInputStore = require('simgate-input-store');

var _simgateInputStore2 = _interopRequireDefault(_simgateInputStore);

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

var _editor = require('./editor');

var _editor2 = _interopRequireDefault(_editor);

var _configurationEntity = require('configuration-entity');

var _simulationEntity = require('simulation-entity');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RegisteredActivityContentModel = _configurationEntity.ContentModels.RegisteredActivityContentModel;
var TaskContentModel = exports.TaskContentModel = (_dec = _mobx.observable.ref, _dec2 = _mobx.observable.ref, _dec3 = _mobx.action.bound, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(TaskContentModel, _BaseContentModel);

  function TaskContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TaskContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TaskContentModel.__proto__ || (0, _getPrototypeOf2.default)(TaskContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'meta', _descriptor, _this), _initDefineProp(_this, '_options', _descriptor2, _this), _this.Editor = _editor2.default, _initDefineProp(_this, 'activityType', _descriptor3, _this), _initDefineProp(_this, 'activity', _descriptor4, _this), _initDefineProp(_this, 'displayTitle', _descriptor5, _this), _initDefineProp(_this, 'description', _descriptor6, _this), _initDefineProp(_this, 'required', _descriptor7, _this), _this.Component = _component2.default, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /* slot( RegisteredActivityContentModel ) */
  /* slot */
  /* slot */
  /* slot */
  /* slot */

  (0, _createClass3.default)(TaskContentModel, [{
    key: 'createActivity',


    // getComponent( opts = {} ){
    //   // if getComponent is called with editMode, the TASK FullEditor is loaded
    //   if(opts.forceFullEditor) return this.FullEditor
    //   // else the computed Component (activity) is loaded
    //   return (this.activity && this.activity.getComponent( opts )) || this.FullEditor
    // }
    // getContentModel( opts = {} ){
    //   // if getContentModel is called with editMode, the TASK contentModel is loaded
    //   if(opts.forceFullEditor) return this
    //   // else the activity contentModel is loaded
    //   return this.activity;
    // }

    // @TODO menu show / enabled somehow configurable via slots... maybe evalled in context?
    value: function createActivity() {
      this.activity = new this.ActivityContentModel({ id: this.id + "_activity", shouldAutoPopulate: true });
    }
  }, {
    key: 'displayName',
    get: function get() {
      return this.displayTitle;
    }

    // /* @input */ @observable @deepBind isCompleted = {
    //   get variable(){ return `G:${this.id}_Completed:G`; },
    //   defaultValue: false //user inputted
    //   get value(){
    //     this.$inputStore.getInput( this.activity, "complete" )
    //   }
    // }

  }, {
    key: 'isCompleted',
    get: function get() {
      if (!this.activity || !this.activity.$inputStore) return false;
      // activity must be saved AND have isCompleted input === true
      var _activity$$inputStore = this.activity.$inputStore,
          isDirty = _activity$$inputStore.isDirty,
          getInput = _activity$$inputStore.getInput;

      return !isDirty && !!getInput(this.activity, "isCompleted");
    }

    // override me
    // @computed get readonly(){
    //   return this.isCompleted.value
    // }

  }, {
    key: 'InputStore',
    get: function get() {
      var _desc2, _value2, _class3, _descriptor8;

      var self = this;
      return _class3 = function (_SimgateInputStore) {
        (0, _inherits3.default)(InputStore, _SimgateInputStore);

        function InputStore() {
          var _ref2;

          var _temp3, _this2, _ret2;

          (0, _classCallCheck3.default)(this, InputStore);

          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = InputStore.__proto__ || (0, _getPrototypeOf2.default)(InputStore)).call.apply(_ref2, [this].concat(args))), _this2), _this2.id = self.id, _initDefineProp(_this2, 'inputs', _descriptor8, _this2), _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
        }

        return InputStore;
      }(_simgateInputStore2.default), (_descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'inputs', [_mobx.observable], {
        enumerable: true,
        initializer: function initializer() {
          return self.allInputs;
        }
      })), _class3;
    }
  }, {
    key: 'allInputs',
    get: function get() {
      if (!this.activity) return {};

      var collectedInputs = this.activity.getAllChildEntitiesFiltered(function (childCm, parentCm, slotName) {
        var slot = parentCm.slots[slotName];
        if (Array.isArray(slot)) slot = slot[0];
        if (slot === _simulationEntity.ContentModel) return false;
      }).map(function (ent) {
        return ent._inputs;
      });

      return _cloner.shallow.merge.apply(_cloner.shallow, [{}].concat((0, _toConsumableArray3.default)(collectedInputs)));
    }
  }, {
    key: 'ActivityContentModel',
    get: function get() {
      return this.activityType && this.activityType.module && this.activityType.module.ContentModel;
    }
  }, {
    key: 'activityDescription',
    get: function get() {
      return this.activityType && this.activityType.module && this.activityType.module.description;
    }
  }, {
    key: 'invalid',
    get: function get() {
      var invalid = (0, _assign2.default)({}, this._invalid);
      if (!this.displayTitle) invalid.displayTitle = "Please provide a display title!";
      if (!this.description) invalid.description = "Please provide a description!";
      if (!this.activityType) invalid.activityType = "Please choose an activityType";
      if (this.activity && this.activity.isNew && this.activity.allChildCms.length && this.activity.allChildCms.some(function (cm) {
        return cm[0].isNew;
      })) {
        invalid.activity = "Please save all submodels";
      }
      return invalid;
    }
  }]);
  return TaskContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  activity: _baseContentmodel2.default,
  activityType: RegisteredActivityContentModel,
  displayTitle: "",
  description: "",
  required: true
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'meta', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      activityType: {
        get readonly() {
          return !this.isNew;
        }
      }
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, '_options', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get activity() {
        var _this3 = this;

        return this.$parent.entities.values().filter(function (entity) {
          var activityType = _this3.activityType;

          return eval("activityType && activityType.ContentModelName === entity.type");
        });
      }
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'activityType', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'activity', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'displayTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'description', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'required', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'displayName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'displayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isCompleted', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isCompleted'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'InputStore', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'InputStore'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allInputs', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allInputs'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'ActivityContentModel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'ActivityContentModel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'activityDescription', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'activityDescription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'invalid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createActivity', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createActivity'), _class.prototype)), _class));
var _default = TaskContentModel;
exports.default = _default;
;

var _temp4 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RegisteredActivityContentModel, 'RegisteredActivityContentModel', 'src/entity_modules/task-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(TaskContentModel, 'TaskContentModel', 'src/entity_modules/task-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/task-entity/contentmodel.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/task-entity/contentmodel.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/contentmodel.js
// module chunks = 0